import { TSortField } from 'shared/types'

export const sortIconPosition = (sortField: TSortField, columnName: string) => {
  if (sortField.fieldName === columnName) {
    return `fa-regular fa-sort-${sortField.direction ? 'up' : 'down'}`
  }

  return 'fa-regular fa-sort'
}
